import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {DailyReportsService} from '../../services/daily-reports.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'daily-reports.component.html',
})
export class DailyReportsComponent implements OnInit, OnDestroy {

    constructor(public dailyReportsService: DailyReportsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.dailyReportsService.getBuildings();

        this.urlService
            .onUrlChange
            .pipe(
                tap(() => this.dailyReportsService.tabId = this.urlService.queryParams['tab']),
                flatMap(
                    () => this.dailyReportsService.getDataByQueryParams(true)
                        .pipe(takeUntil(this.urlService.instantOnUrlChange))
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allDailyReports');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.dailyReportsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.dailyReportsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports.component.ts